import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import axios from '../../helpers/axios';
import { Grid, Card, CardContent, CardHeader, IconButton, Button, Typography, CardActions, Modal, Box, Divider, Select, InputLabel, TextField, FormControl, MenuItem } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withTranslation, WithTranslation } from 'react-i18next';
import OperationsHeader from './OperationsHeader';
import { DataGrid, GridRowParams, GridActionsCellItem, GridCellParams } from '@mui/x-data-grid';
import { EditOutlined, Add, Security as SecurityIcon, FileCopy as FileCopyIcon, CloseOutlined } from '@mui/icons-material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '65%',
    p: 4,
};

export interface IProps {
    user: {
        id: number;
        name: string;
        email: string;
        role: string;
        is_active: boolean;
    };
}

export interface IState {
    vehicles: any[];
    pageSize: number;
    showAddVehicle: boolean;
    vehicleRegistrationDate?: string | null;
    vehicleMocciid: string;
    vehicleBanjar: string;
    vehicleVendor: string;
    vehicleAmount: number;
    vehicleAge: number;
    vehicleCondition: string;
}

class Maintenance extends React.Component<RouteComponentProps & IProps & WithTranslation, IState> {
    constructor(props: RouteComponentProps & IProps & WithTranslation) {
        super(props);
        this.state = {
            vehicles: [],
            pageSize: 5,
            showAddVehicle: false,
            vehicleRegistrationDate: null,
            vehicleMocciid: '',
            vehicleBanjar: '',
            vehicleVendor: '',
            vehicleAmount: 0,
            vehicleAge: 0,
            vehicleCondition: ''
        }
    }
    public componentDidMount(): void {
        // axios.get(`vehicles`).then(response => {
        //     this.setState({ vehicles: response.data.data })
        // });
        this.setState({
            vehicles: [
                {
                    "id": 1,
                    "date": "2021-03-12",
                    "mocciid": "W943RD0901",
                    "banjar": "NA",
                    "vendor": "TATA Motors",
                    "amount": 867000,
                    "age": 2,
                    "condition": "Good"
                },
                {
                    "id": 2,
                    "date": "2021-03-12",
                    "mocciid": "W943RD0902",
                    "banjar": "NA",
                    "vendor": "Benz",
                    "amount": 832000,
                    "age": 4,
                    "condition": "Good"
                },
                {
                    "id": 3,
                    "date": "2021-03-12",
                    "mocciid": "W943RD0903",
                    "banjar": "NA",
                    "vendor": "ISUZU",
                    "amount": 823000,
                    "age": 7,
                    "condition": "Average"
                },
                {
                    "id": 4,
                    "date": "2021-03-12",
                    "mocciid": "W943RD0904",
                    "banjar": "NA",
                    "vendor": "Volvo",
                    "amount": 876000,
                    "age": 2,
                    "condition": "Good"
                },
                {
                    "id": 5,
                    "date": "2021-03-12",
                    "mocciid": "W943RD0905",
                    "banjar": "NA",
                    "vendor": "Mitsubishi",
                    "amount": 881000,
                    "age": 2,
                    "condition": "Good"
                },
                {
                    "id": 6,
                    "date": "2021-03-12",
                    "mocciid": "W943RD0906",
                    "banjar": "NA",
                    "vendor": "TATA Motors",
                    "amount": 797000,
                    "age": 2,
                    "condition": "Good"
                }
            ]
        })
    }

    public render() {
        if (!localStorage.getItem('token')) {
            return (
                <Redirect to="/login" />
            );
        }
        const { t } = this.props;

        const handleCellClick = (params: GridCellParams) => {
            console.log(params);
        };

        const handleAddVehicle = (() => {
            this.setState({ showAddVehicle: false });
            toast.success("Vehicle added", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored"
            });
        });

        const columns: any = [
            {
                headerName: "Date",
                field: "date",
                type: "date",
                width: 120
            },
            {
                headerName: "Mocciid",
                field: "mocciid",
                width: 120
            },
            {
                headerName: "Banjar",
                field: "banjar",
                width: 100
            },
            {
                headerName: "Vendor",
                field: "vendor",
                width: 120
            },
            {
                headerName: "Amount/Cost  (IN RP)",
                field: "amount",
                width: 170
            },
            {
                headerName: "AGE (IN YEARS)",
                field: "age",
                width: 150
            },
            {
                headerName: "Condition",
                field: "condition",
                width: 120,
                renderCell: (params: GridCellParams) => (
                    <Typography className={(params.row.condition == 'Good') ? 'statusTextSuccess' : 'statusTextError'}>{params.row.condition}</Typography>
                )
            },
            {
                headerName: "Actions",
                field: 'actions',
                type: 'actions',
                getActions: (params: GridRowParams) => [
                    <GridActionsCellItem
                        // icon={<FileCopyIcon />}    
                        label="Edit Vehicle Details"
                        onClick={() => console.log(params.id)}
                        showInMenu
                    />,
                    <GridActionsCellItem
                        label="Delete Vehicle"
                        onClick={() => console.log(params.id)}
                        showInMenu
                    />
                ]
            }
        ];

        return (
            <div>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                <OperationsHeader />
                <Grid container spacing={2}>
                    <Grid item md={12} xs={12} className="mt-3">
                        <Card>
                            <CardHeader
                                title="Vehicle Maintenance"
                                className="text-left"
                                action={
                                    <CardActions>
                                        <Button size='small' variant='contained' className='link' component={Link} to={'/operations/vehicle-maintenance-charts'}>View Charts</Button>
                                        <Button size='small' variant='contained' className='link' sx={{marginLeft: '10px'}}>View Repair</Button>
                                    </CardActions>
                                }
                            />
                            
                            <CardContent>
                                <Grid container spacing={2}>
                                    <Grid item md={12} xs={12} className="mt-3">
                                        <Card>
                                            <CardHeader
                                                title="Vehicles List"
                                                className="text-left"
                                                action={
                                                    <Button variant="contained" size="small" sx={{ outline: 'none !important' }} onClick={() => this.setState({ showAddVehicle: true })}>
                                                        <Add /> Add New Vehicle
                                                    </Button>
                                                }
                                            />
                                            <CardContent>
                                                <DataGrid
                                                    aria-label="Vehicles List"
                                                    columns={columns}
                                                    rows={this.state.vehicles}
                                                    pageSize={this.state.pageSize}
                                                    onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
                                                    rowsPerPageOptions={[2, 5, 10, 20]}
                                                    autoHeight={true}
                                                    components={{
                                                        MoreActionsIcon: EditOutlined,
                                                    }}
                                                    checkboxSelection
                                                />
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                <Modal
                    open={this.state.showAddVehicle}
                    onClose={() => this.setState({ showAddVehicle: false })}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Card>
                            <CardHeader
                                title="Add Vehicle"
                                className="text-left"
                                action={
                                    <IconButton color="primary" className='customIconButton' aria-label="upload picture" component="span" onClick={() => this.setState({ showAddVehicle: false })}>
                                        <CloseOutlined />
                                    </IconButton>
                                }
                            />
                            <CardContent>
                                <Divider className="mb-3" />
                                <Grid container spacing={2}>
                                    <Grid item md={4} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DatePicker
                                                    renderInput={(props) => <TextField {...props} />}
                                                    label="Date *"
                                                    views={['year', 'month', 'day']}
                                                    value={this.state.vehicleRegistrationDate}
                                                    onChange={(newValue: any) => {
                                                        this.setState({ vehicleRegistrationDate: newValue });
                                                    }}
                                                />
                                            </LocalizationProvider>
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="mocciid-input"
                                            label="Mocciid *"
                                            value={this.state.vehicleMocciid}
                                            onChange={(e: any) => this.setState({ vehicleMocciid: e.target.value })}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="banjar-input"
                                            label="Banjar *"
                                            value={this.state.vehicleBanjar}
                                            onChange={(e: any) => this.setState({ vehicleBanjar: e.target.value })}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <InputLabel id="vendor-label">Vendor *</InputLabel>
                                            <Select
                                                labelId="vendor-label"
                                                value={this.state.vehicleVendor}
                                                onChange={(e) => this.setState({ vehicleVendor: e.target.value })}
                                                displayEmpty
                                                label="Vendor *"
                                                fullWidth={true}
                                            >
                                                <MenuItem key={1} value={'TATA Motors'}>TATA Motors</MenuItem>
                                                <MenuItem key={2} value={'Benz'}>Benz</MenuItem>
                                                <MenuItem key={3} value={'ISUZU'}>ISUZU</MenuItem>
                                                <MenuItem key={4} value={'Volvo'}>Volvo</MenuItem>
                                                <MenuItem key={5} value={'Mitsubishi'}>Mitsubishi</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="vehicle-amount-input"
                                            label="Amount/Cost (IN RP) *"
                                            type={'number'}
                                            InputProps={{
                                                inputProps: { min: 0 }
                                            }}
                                            value={this.state.vehicleAmount}
                                            onChange={(e: any) => this.setState({ vehicleAmount: e.target.value })}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="vehicle-age-input"
                                            label="Age (In Years) *"
                                            type={'number'}
                                            InputProps={{
                                                inputProps: { min: 0 }
                                            }}
                                            value={this.state.vehicleAge}
                                            onChange={(e: any) => this.setState({ vehicleAge: e.target.value })}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <InputLabel id="condition-label">Condition *</InputLabel>
                                            <Select
                                                labelId="condition-label"
                                                value={this.state.vehicleCondition}
                                                onChange={(e) => this.setState({ vehicleCondition: e.target.value })}
                                                displayEmpty
                                                label="Condition *"
                                                fullWidth={true}
                                            >
                                                <MenuItem key={1} value={'Good'}>Good</MenuItem>
                                                <MenuItem key={2} value={'Average'}>Average</MenuItem>
                                                <MenuItem key={3} value={'Bad'}>Bad</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <Divider className='mt-3' />
                            </CardContent>
                            <CardActions className='float-right'>
                                <Button size='small' className='customCloseButton' onClick={() => this.setState({ showAddVehicle: false })}>Close</Button>
                                <Button size='small' variant='contained' sx={{ outline: 'none !important' }} onClick={() => handleAddVehicle()}>Add Vehicle</Button>
                            </CardActions>
                        </Card>
                    </Box>
                </Modal>
            </div>
        )
    }
}

export default withRouter(withTranslation()(Maintenance))